import React from 'react';

/* The kiosk has one screen and no address bar, so this is only reachable
   if something on the network sends it somewhere odd. It says so plainly
   and offers the way back. */
function NotFound() {
    return (
        <div className="kiosk">
            <div className="kiosk__aurora" aria-hidden="true"><span /><span /></div>
            <div className="kiosk__vignette" aria-hidden="true" />

            <div />
            <div className="welcome">
                <h1 className="welcome__title">This screen isn’t available.</h1>
                <p className="welcome__lead">
                    The dashboard could not find that view. Return to the building home screen.
                </p>
                <p className="welcome__hint" style={{ marginTop: '2rem' }}>
                    <a href="/">Back to the dashboard</a>
                </p>
            </div>
            <div />
        </div>
    );
}

export default NotFound;
